module.exports = __webpack_public_path__ + "img/res4.ee50dccf.png";